import { render, staticRenderFns } from "./CriterionIndex.vue?vue&type=template&id=72d6acf9&scoped=true&"
import script from "./CriterionIndex.vue?vue&type=script&lang=js&"
export * from "./CriterionIndex.vue?vue&type=script&lang=js&"
import style0 from "./CriterionIndex.vue?vue&type=style&index=0&id=72d6acf9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d6acf9",
  null
  
)

export default component.exports